import { useState } from 'react'
import { Link } from 'react-router'
import { useRequestPasswordReset } from '../hooks/useAuth'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const requestReset = useRequestPasswordReset()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    requestReset.mutate(email)
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="sidebar-brand-icon">×</div>
          <h1>
            double<span style={{ color: 'var(--accent-primary)' }}>·</span>xl
          </h1>
          <p className="text-muted">Studio OS</p>
        </div>

        {requestReset.isSuccess ? (
          <div className="login-form">
            <p>
              If an account exists for <strong>{email}</strong>, a reset link is on its way.
              The link expires in 1 hour.
            </p>
            <Link to="/" className="btn btn-primary btn-full">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <p className="text-muted">
              Enter your email and we&apos;ll send you a password reset link.
            </p>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@double-xl.cloud"
                required
                autoComplete="email"
              />
            </div>

            {requestReset.error && (
              <p className="form-error">
                {(requestReset.error as any)?.body?.error?.message || 'Request failed'}
              </p>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-full"
              disabled={requestReset.isPending}
            >
              {requestReset.isPending ? 'Sending...' : 'Send reset link'}
            </button>
            <Link to="/" className="text-muted" style={{ textAlign: 'center', display: 'block' }}>
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  )
}
